import { useState } from "react";

export interface UseBooleanCallbacks {
    setTrue: () => void;
    setFalse: () => void;
    toggle: () => void;
}

/**
 * Stores a boolean and returns `setTrue` / `setFalse` / `toggle` callbacks whose identity never changes,
 * so they are safe to use in hook dependency lists. Same API as Fluent UI v8's `useBoolean`, which it replaced.
 */
export const useBoolean = (initialState: boolean): [boolean, UseBooleanCallbacks] => {
    const [value, setValue] = useState(initialState);
    const [callbacks] = useState<UseBooleanCallbacks>(() => ({
        setTrue: () => setValue(true),
        setFalse: () => setValue(false),
        toggle: () => setValue((currentValue) => !currentValue)
    }));

    return [value, callbacks];
};
